var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var ServiceFeeSettingsService_1;
var _a, _b, _c;
import { makeAutoObservable } from "mobx";
import { Money, Percentage } from "../core";
import { perRestaurant } from "../di";
import { Restaurant } from "./Restaurant";
import { Payment } from "./Payment";
import { OrderReceiver } from "./OrderReceiver";
const FIXED_SERVICE_FEE_PERCENTAGE = Percentage.fromNumber(1.5);
// Countries absent from this map are not charged a service fee.
const SERVICE_FEE_BOUNDS = {
    PL: { min: Money.fromCents(90), max: Money.fromCents(450) },
    SK: { min: Money.fromCents(25), max: Money.fromCents(100) },
};
let ServiceFeeSettingsService = ServiceFeeSettingsService_1 = class ServiceFeeSettingsService {
    constructor(restaurant, payment, orderReceiver) {
        this.restaurant = restaurant;
        this.payment = payment;
        this.orderReceiver = orderReceiver;
        makeAutoObservable(this);
    }
    get isApplicable() {
        if (!(this.restaurant.orderingPolicy.country in SERVICE_FEE_BOUNDS)) {
            return false;
        }
        if (this.payment.method !== "Online") {
            return false;
        }
        if (this.orderReceiver.invoiceRequest !== null) {
            return false;
        }
        return true;
    }
    get percentage() {
        if (!this.isApplicable) {
            return null;
        }
        return ServiceFeeSettingsService_1.getPercentage(this.restaurant.orderingPolicy.serviceFeeSettings);
    }
    get bounds() {
        var _a;
        if (!this.isApplicable) {
            return null;
        }
        return (_a = SERVICE_FEE_BOUNDS[this.restaurant.orderingPolicy.country]) !== null && _a !== void 0 ? _a : null;
    }
    static getPercentage(settings) {
        switch (settings.tag) {
            case "FixedPercentage":
                return FIXED_SERVICE_FEE_PERCENTAGE;
            case "Percentage":
                return Percentage.fromNumber(settings.contents);
            case "None":
                return null;
        }
    }
    static getBoundsForCountry(country) {
        var _a;
        return (_a = SERVICE_FEE_BOUNDS[country]) !== null && _a !== void 0 ? _a : null;
    }
};
ServiceFeeSettingsService = ServiceFeeSettingsService_1 = __decorate([
    perRestaurant(),
    __metadata("design:paramtypes", [typeof (_a = typeof Restaurant !== "undefined" && Restaurant) === "function" ? _a : Object, typeof (_b = typeof Payment !== "undefined" && Payment) === "function" ? _b : Object, typeof (_c = typeof OrderReceiver !== "undefined" && OrderReceiver) === "function" ? _c : Object])
], ServiceFeeSettingsService);
export { ServiceFeeSettingsService };
